import { Injectable } from '@angular/core';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import {Observable, of} from 'rxjs';
import {MatDialog} from "@angular/material/dialog";


@Injectable({
  providedIn: 'root'
})
export class PopupCloseGuard implements CanDeactivate<unknown> {

  constructor() { }

  /**
   * Prevent navigation if a dialog is open, close dialog instead
   * The purpose of this guard is to mime the mobile behaviour
   * where a dialog can be closed with the back button
   * @param component
   * @param currentRoute
   * @param currentState
   * @param nextState
   */
  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree
  {
    return of(true);
  }

}
